var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    fill: "none",
    viewBox: "0 0 18 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 12a.97.97 0 0 1-.712-.287A.97.97 0 0 1 0 11q0-.424.288-.713A.97.97 0 0 1 1 10h16q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 17 12zm0-5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 0 6q0-.424.288-.713A.97.97 0 0 1 1 5h16q.424 0 .712.287Q18 5.576 18 6q0 .424-.288.713A.97.97 0 0 1 17 7zm0-5a.97.97 0 0 1-.712-.288A.97.97 0 0 1 0 1Q0 .576.288.288A.97.97 0 0 1 1 0h16q.424 0 .712.288Q18 .575 18 1q0 .424-.288.712A.97.97 0 0 1 17 2z"
  })));
};
export default SvgHamburger;